document.addEventListener("DOMContentLoaded", function () {
  /* Initializes the wishlist functions by fetching the list and adding event listeners. */
  const init = (swat) => {
    fetchList(swat).then(() => {
      if (!window.swymSelectedListId) {
        createList(swat);
      }
      addSwymEventListener(swat);
    });
  };

  const createList = (swat) => {
    const listConfig = { lname: "My Wishlist" };

    const onSuccess = ({ lid }) => {
      console.log("Successfully created a new List", lid);
      window.swymSelectedListId = lid;
    };

    const onError = (error) => {
      console.log("Error while creating a List", error);
    };

    swat.createList(listConfig, onSuccess, onError);
  };

  const fetchList = async (swat) => {
    return new Promise((resolve, reject) => {
      const onSuccess = (lists) => {
        console.log("Fetched all Lists", lists);
        window.swymWishLists = lists;
        window.swymSelectedListId = lists?.[0]?.lid;
        updateButtonState();
        resolve(lists);
      };

      const onError = (error) => {
        console.log("Error while fetching all Lists", error);
        reject(error);
      };

      if (!window.swymWishLists) {
        swat.fetchLists({ callbackFn: onSuccess, errorFn: onError });
      } else {
        resolve(window.swymWishLists);
      }
    });
  };

  const refreshList = async (swat) => {
    window.swymWishLists = null;
    await fetchList(swat);
  };

  const addToWishlist = (swat, product) => {
    const onSuccess = (addedListItem) => {
      console.log("Product added to wishlist!", addedListItem);
    };

    const onError = () => {
      swat.ui.showErrorNotification({ message: "Error Adding Product to Wishlist" });
    };

    const lid = window.swymSelectedListId;
    swat.addToList(lid, product, onSuccess, onError);
  };

  const removeFromWishlist = (swat, product) => {
    const onSuccess = (deletedProduct) => {
      console.log("Product removed from wishlist!", deletedProduct);
    };

    const onError = () => {
      swat.ui.showErrorNotification({ message: "Error removing Product from Wishlist" });
    };

    const lid = window.swymSelectedListId;
    swat.deleteFromList(lid, product, onSuccess, onError);
  };

  const updateButtonState = () => {
    const swymWishlistButtons = document.querySelectorAll("swymcs-wishlist-button");
    if (!swymWishlistButtons) return;

    swymWishlistButtons.forEach((swymWishlistButton) => {
      const elements = swymWishlistButton.elements;
      const { epi, empi } = elements.wishlistButton.dataset;
      let isWishlisted = false;

      window.swymWishLists?.forEach((list) => {
        list.listcontents.forEach((item) => {
          if (item.empi == empi && item.epi == epi) {
            isWishlisted = true;
          }
        });
      });

      updateButtonWishlistState(elements, isWishlisted);
    });
  };

  const updateButtonWishlistState = (elements, isWishlisted) => {
    const settings = JSON.parse(elements.wishlistButton.dataset.settings);
    elements.filledState.style.display = isWishlisted ? "flex" : "none";
    elements.unfilledState.style.display = isWishlisted ? "none" : "flex";

    if (isWishlisted) {
      elements.wishlistButton.classList.add("swym-added-custom");
      if (settings.disable_added_to_wishlist) {
        elements.wishlistButton.setAttribute("disabled", true);
      }
    } else {
      elements.wishlistButton.classList.remove("swym-added-custom", "disabled");
      elements.wishlistButton.removeAttribute("disabled");
    }
  };

  const renderPopup = async (product) => {
    const popup = document.querySelector("swym-wishlist-popup");
    const { epi, empi, du } = product;

    const fetchedProduct = await fetchProductsData(du);

    if (!fetchedProduct) {
      console.warn(`renderPopup aborted: Could not fetch product data for URL: ${du}`);
      return;
    }

    const matchingVariant = fetchedProduct.variants.find((v) => v.id == epi);

    if (!matchingVariant) {
      console.warn(`renderPopup aborted: Variant ${epi} not found in product ${du}`);
      return;
    }

    window.currentActiveProduct = fetchedProduct;
    window.currentActiveVariant = matchingVariant;
    window.currentActiveVariantId = epi;
    window.currentActiveProduct.url = du;

    setTimeout(() => popup._show(), 100);
  };

  const fetchProductsData = async (url) => {
    try {
      const jsUrl = `${url}.js`;
      console.log("Fetching product data from:", jsUrl);

      const res = await fetch(jsUrl);

      if (!res.ok) {
        console.warn(`Product fetch failed. Status: ${res.status} (${res.statusText})`);
        return null;
      }

      const text = await res.text();

      if (!text || !text.trim().startsWith('{')) {
        console.warn(`Invalid or non-JSON response from ${jsUrl}`);
        return null;
      }

      return JSON.parse(text);
    } catch (err) {
      console.error("Unexpected error during product data fetch:", err);
      return null;
    }
  };

  const addSwymEventListener = (swat) => {
    swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, (event) => {
      const { iu: image, dt: title } = event.detail.d;
      showCustomNotification(swat, image, title, "remove", 1);
      refreshList(swat);
    });

    swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, (event) => {
      const { iu: image, dt: title } = event.detail.d;
      showCustomNotification(swat, image, title, "add", 1);
      refreshList(swat);
    });

    swat.evtLayer.addEventListener(swat.JSEvents.variantChanged, (data) => {
      const currentVariant = data.detail.d.variant.id;
      const currentProductId = data.detail.d.product.id;
      const button = document.querySelector(`.swymcs-wishlist-button-${currentProductId}`);
      if (button) {
        button.setAttribute("data-epi", currentVariant);
      }
      setTimeout(updateButtonState, 200);
    });
  };

  const showCustomNotification = (swat, image, title, action, listCount) => {
    const message = `
      <style>
        .swym-notification-success-inner .swym-image{ display: none !important }
        #swym-custom-notification-content { display: flex; gap: 10px; align-items: center; cursor: pointer }
        #swym-custom-notification-content #swym-custom-image-container { min-height: 50px; min-width: 50px; max-height: 50px; max-width: 50px }
        #swym-custom-notification-content #swym-custom-image-container #swym-custom-image { width: 100%; height: 100%; object-fit: cover; border-radius: 50% }
        #swym-custom-notification-content #swym-custom-title-container { font-weight: 500; font-size: 14px }
      </style>
      <div id="swym-custom-notification-content" onclick="_swat.ui.open()">
        <div id="swym-custom-image-container">
          <img id="swym-custom-image" src="${image}" alt="wishlisted product image"/>
        </div>
        <div id="swym-custom-title-container"><strong>${title}</strong> has been ${action === 'remove' ? 'removed from' : 'added to'} <strong>${listCount === 1 ? 'list!' : 'lists!'}</strong></div>
      </div>
    `;
    swat.ui.showSuccessNotification({ message });
  };

  // Global exposure
  const swymcsWishlistFunctions = {
    init,
    fetchList,
    refreshList,
    updateButtonState,
    updateButtonWishlistState,
    addToWishlist,
    removeFromWishlist,
    addSwymEventListener,
    fetchProductsData,
    renderPopup,
    showCustomNotification
  };

  window.swymcsWishlistFunctions = swymcsWishlistFunctions;

  // Push to SwymCallbacks
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(swymcsWishlistFunctions.init);

  // Auto-init if _swat already exists
  if (typeof _swat !== "undefined") {
    swymcsWishlistFunctions.init(_swat);
  }
});
